import { useState, useRef } from "react";
import projects from "../../../api/projects.json";
import styles from "./Works.module.scss";
import { useNavigate } from "react-router-dom";
import useIntersection from "../../../hooks/useIntersection";
import FeaturedCard from "./children/featureCard/FeatureCard";
import ProjectCard from "./children/projectCard/ProjectCard";

const FILTERS = ["All", "Full Stack", "Web App", "Mobile App"];

export default function Works() {
  const [filter, setFilter] = useState("All");
  const ref = useRef(null);
  const visible = useIntersection(ref, 0.05);
  const navigate = useNavigate();

  const list =
    filter === "All"
      ? projects.toReversed()
      : projects.toReversed().filter((p) => p.category === filter);
  const featured = list.filter((p) => p.featured);
  const regular = list.filter((p) => !p.featured);

  return (
    <>
      <section id="projects" className={styles["ps-section"]} ref={ref}>
        <div
          className={styles["ps-header"]}
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity .6s,transform .6s",
          }}
        >
          <h2>My Projects</h2>
          <div className={styles["ps-underline"]} />
          <p>
            A curated showcase of real world solutions crafted with precision
            and passion.
          </p>
        </div>

        <div
          className={styles["ps-filters"]}
          style={{
            opacity: visible ? 1 : 0,
            transition: "opacity .6s ease .2s",
          }}
        >
          {FILTERS.map((f) => (
            <button
              key={f}
              className={`${styles["ps-filter-btn"]}${filter === f ? ` ${styles["active"]}` : ""}`}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>

        <div className={styles["ps-grid"]}>
          {featured.map((p, i) => (
            <FeaturedCard
              key={p.id}
              project={p}
              visible={visible}
              index={i}
              onClick={() => {
                navigate(`/project/${p.id}`);
              }}
            />
          ))}
          {regular.map((p, i) => (
            <ProjectCard
              key={p.id}
              project={p}
              visible={visible}
              index={featured.length + i}
              onClick={() => {
                navigate(`/project/${p.id}`);
              }}
            />
          ))}
        </div>
      </section>
    </>
  );
}
